import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type SingleCurrencyClasses =
  | 'priceWithButtonSectionItem'
  | 'priceContainer'
  | 'priceSectionContainer'
  | 'loader';

const singleCurrencyStyles = makeStyles<ISpcTheme, SingleCurrencyClasses>(
  ({ breakpoints }) => ({
    priceContainer: {
      [breakpoints.down(breakpoints.values.sm)]: {
        position: 'relative',
        top: -30,
      },
    },
    priceWithButtonSectionItem: {
      paddingLeft: 20,
      [breakpoints.down('xs')]: {
        padding: '8px 0',
      },
    },
    priceSectionContainer: {
      [breakpoints.down(breakpoints.values.sm)]: {
        width: '40%',
      },
    },
    loader: {
      width: '180px',
      display: 'flex',
      justifyContent: 'center',

      [breakpoints.down('sm')]: {
        width: '150px',
        marginRight: '30px',
      },
    },
  }),
  { name: 'Customise_SingleCurrency' },
);

export default singleCurrencyStyles;
